export enum eAccessControlLogoutReason {
  STANDARD = 'standard',
  EXPIRED = 'expired',
  ADMIN_REDIRECT = 'admin-redirect',
}
